import type { Audit, Comment } from '@/models/registry';
import type { AuditLog, Trade } from '@/models/types';

import AuditLine from '../../deal/activity-feed/audit-line';
import CombinedAuditLine, {
  type CombinedAuditLog,
} from '../../deal/activity-feed/combined-audit-line';
import Thread from './thread';

export type AuditTrailLogs = (AuditLog | CombinedAuditLog)[];

// PRODUCT NOTE: the audit trail is a list of things that happened to the trade.
// .i.e. a list of audit logs, comments, and combined audit logs.
// (Thus, it does not include the add comment button because
// that has not happened yet.)
const AuditTrail = ({
  auditLogs,
  audits,
  comments,
  tradeId,
  tradeShortId,
}: {
  auditLogs: AuditTrailLogs;
  audits: Audit[];
  comments: Comment[];
  tradeId: Trade['id'];
  tradeShortId: Trade['short_id'];
}) => {
  return (
    <>
      {auditLogs.map((auditLog) => {
        switch (auditLog.type) {
          case 'audit':
            const audit = audits.find((a) => a.id === auditLog.id);
            if (!audit) return null;

            return <AuditLine key={audit.id} audit={audit} />;
          case 'comment':
            const comment = comments.find((c) => c.id === auditLog.id);
            if (!comment) return null;
            return (
              <Thread
                key={comment.id}
                comment={comment}
                tradeId={tradeId}
                tradeShortId={tradeShortId}
              />
            );
          case 'combined-audit':
            return (
              <CombinedAuditLine
                key={`combined-audit-${auditLog.groupId}`}
                auditLog={auditLog}
                audits={audits}
              />
            );
        }
      })}
    </>
  );
};

export default AuditTrail;
